var _defs, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g2, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _g3, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect41, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _rect42, _rect43, _path13, _rect44, _rect45, _path14, _rect46, _rect47, _path15, _rect48, _rect49, _path16, _rect50, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g4, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _rect51, _rect52, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _g5, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _rect53, _path165;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 159.966,
    height: 98.316,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 9.064,
    height: 9.875,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 11.571,
    height: 11.657,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 199,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 198,
    height: 198,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(21.034 53.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 31.292,
    height: 59.276,
    transform: "translate(35.122 7.319)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 28.524,
    height: 36.826,
    transform: "translate(36.505 28.112)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 8.798,
    height: 8.798,
    transform: "translate(36.505 8.493)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 8.798,
    height: 8.798,
    transform: "translate(46.368 8.493)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 8.798,
    height: 8.798,
    transform: "translate(56.231 8.493)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 8.798,
    height: 8.798,
    transform: "translate(36.505 18.142)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 8.798,
    height: 8.798,
    transform: "translate(46.368 18.142)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 8.798,
    height: 8.798,
    transform: "translate(56.231 18.142)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 31.291,
    height: 59.276,
    transform: "translate(0.131 7.319)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 28.524,
    height: 36.826,
    transform: "translate(1.515 28.112)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 8.798,
    height: 8.798,
    transform: "translate(1.515 8.493)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 8.798,
    height: 8.798,
    transform: "translate(11.377 8.493)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 8.798,
    height: 8.798,
    transform: "translate(21.24 8.493)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 8.798,
    height: 8.798,
    transform: "translate(1.515 18.142)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 8.798,
    height: 8.798,
    transform: "translate(11.377 18.142)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 8.798,
    height: 8.798,
    transform: "translate(21.24 18.142)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 13.319,
    height: 22.711,
    transform: "translate(84.573 7.502)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 3.71,
    height: 3.71,
    transform: "translate(85.337 8.258)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 8.937)",
    fill: "#b6c2ff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 9.943)",
    fill: "#b6c2ff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 10.95)",
    fill: "#b6c2ff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 3.71,
    height: 3.71,
    transform: "translate(85.337 13.084)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 13.763)",
    fill: "#b6c2ff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 14.769)",
    fill: "#b6c2ff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 15.775)",
    fill: "#b6c2ff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 3.71,
    height: 3.71,
    transform: "translate(85.337 17.909)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 18.588)",
    fill: "#b6c2ff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 19.594)",
    fill: "#b6c2ff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 20.601)",
    fill: "#b6c2ff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 3.71,
    height: 3.71,
    transform: "translate(85.337 22.734)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 23.413)",
    fill: "#b6c2ff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 24.42)",
    fill: "#b6c2ff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 6.959,
    height: 0.339,
    transform: "translate(90.053 25.426)",
    fill: "#b6c2ff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M325.174,8.088,331.1.793l5.929,7.295",
    transform: "translate(-240.019 -0.585)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 16.333,
    height: 46.438,
    transform: "translate(135.009 42.116)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 23.153,
    height: 49.536,
    transform: "translate(131.598 39.017)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 16.333,
    height: 46.438,
    transform: "translate(111.856 42.116)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 23.153,
    height: 49.536,
    transform: "translate(108.446 39.017)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 16.333,
    height: 46.438,
    transform: "translate(88.703 42.116)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 23.153,
    height: 49.536,
    transform: "translate(85.293 39.017)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 72.389,
    height: 3.031,
    transform: "translate(83.828 35.986)",
    fill: "none",
    stroke: "#b6c2ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 0.802,
    height: 15.491,
    transform: "translate(136.253 57.589)",
    fill: "#b6c2ff"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 0.802,
    height: 15.491,
    transform: "translate(113.342 57.589)",
    fill: "#b6c2ff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 0.802,
    height: 15.491,
    transform: "translate(90.43 57.589)",
    fill: "#b6c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M204.153,222.4a11.1,11.1,0,0,0-6.4,4.042,16.991,16.991,0,0,0-3.177,6.968,36.673,36.673,0,0,0-.724,7.676,9.543,9.543,0,0,0,8.527-3.575,12.608,12.608,0,0,0,2.275-7.314,37.95,37.95,0,0,0-.5-7.8",
    transform: "translate(-143.09 -164.159)",
    fill: "#74dbff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M201.206,223.881a18.441,18.441,0,0,0-3.741,3.889,33.342,33.342,0,0,0-2.846,4.67,36.2,36.2,0,0,0-3.416,10.448,35.74,35.74,0,0,0-.477,6.139.13.13,0,0,0,.26,0,35.723,35.723,0,0,1,1.564-10.753,35.285,35.285,0,0,1,4.681-9.729,18.882,18.882,0,0,1,4.106-4.439c.132-.1,0-.325-.131-.224",
    transform: "translate(-140.778 -165.233)",
    fill: "#0037a4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M181.289,219.792A23.3,23.3,0,0,1,179,208.442a13.57,13.57,0,0,1,5.91-10.1,21.434,21.434,0,0,1,2.561,11.5c-.367,3.94-2.915,7.137-6.184,9.948",
    transform: "translate(-132.073 -146.403)",
    fill: "#7a7fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M189.521,202.869q-1.027,2.867-1.774,5.823-.742,2.938-1.2,5.937t-.634,6.029q-.174,3.025-.06,6.057t.521,6.039q.051.375.106.75c.024.165.275.095.251-.069a63.344,63.344,0,0,1,3.042-30.5c.057-.158-.195-.226-.251-.069",
    transform: "translate(-137.148 -149.677)",
    fill: "#0037a4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M139.024,211.881a21.68,21.68,0,0,1,7.905,10.457,48.746,48.746,0,0,1,2.479,12.5,13.27,13.27,0,0,1-9.779-6.1,15.116,15.116,0,0,1-1.713-6.339,35.151,35.151,0,0,1,1.107-10.524",
    transform: "translate(-101.745 -156.395)",
    fill: "#74dbff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M145.031,217.6c2.621,2.556,4.228,5.94,5.638,9.266a76.044,76.044,0,0,1,3.723,11.1q.808,3.2,1.335,6.47c.027.165.277.095.251-.069a76.379,76.379,0,0,0-2.777-11.466q-.92-2.822-2.057-5.566A51.969,51.969,0,0,0,148.8,222.3a20.449,20.449,0,0,0-3.584-4.891c-.12-.117-.3.067-.184.184",
    transform: "translate(-107.022 -160.451)",
    fill: "#0037a4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M173.037,320.892h-9.528l-1.69-11.849h12.909Z",
    transform: "translate(-119.442 -228.112)",
    fill: "#0037a4"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 14.846,
    height: 2.773,
    transform: "translate(41.408 78.851)",
    fill: "#0044c3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M514.184,191.127a17.412,17.412,0,0,0-2.134-5.994,8.738,8.738,0,0,0-4.884-3.905,5.885,5.885,0,0,0-5.883,1.511,6.048,6.048,0,0,0-1.423,3.373,10.642,10.642,0,0,0,.317,3.687,17.574,17.574,0,0,0,11.206,12.255,3.842,3.842,0,0,0,2.551.213c.607-.253.671-.843.729-1.433a33.828,33.828,0,0,0,0-6.256q-.155-1.736-.482-3.45",
    transform: "translate(-368.923 -133.599)",
    fill: "#4275e2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M520.317,186.873a34.294,34.294,0,0,1,5.906,9.243,40.055,40.055,0,0,1,2.427,10.673c.224,2.053.366,4.115.5,6.175.011.166.271.167.26,0a85.042,85.042,0,0,0-1.242-11.1,33.6,33.6,0,0,0-1.486-5.277,27.508,27.508,0,0,0-2.477-4.943,43.9,43.9,0,0,0-3.708-4.959c-.108-.128-.291.057-.184.184",
    transform: "translate(-384.034 -137.768)",
    fill: "#0037a4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M557.587,193.045a8.7,8.7,0,0,1,2.339-3.039A4.662,4.662,0,0,1,563.543,189a4.4,4.4,0,0,1,2.966,2.272,6.457,6.457,0,0,1,.642,3.751,12.368,12.368,0,0,1-1.094,3.689,13.5,13.5,0,0,1-3.461,4.9,7.831,7.831,0,0,1-4.448,1.921,1.625,1.625,0,0,1-1.13-.346,2.407,2.407,0,0,1-.594-1.509c-.136-.742-.269-1.482-.347-2.233a15.159,15.159,0,0,1,.14-4.308,15.342,15.342,0,0,1,1.369-4.1",
    transform: "translate(-410.389 -139.46)",
    fill: "#114bbc"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M566.17,194.209c-2.145,2.36-2.992,5.6-3.683,8.632a55.39,55.39,0,0,0-1.224,16.56c.013.166.273.167.26,0a55.385,55.385,0,0,1,.2-10.527q.3-2.633.856-5.229a39.785,39.785,0,0,1,1.276-4.769,12.841,12.841,0,0,1,2.5-4.484c.112-.124-.071-.308-.184-.184",
    transform: "translate(-414.162 -143.32)",
    fill: "#0037a4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M564.114,227.152a7.693,7.693,0,0,1,7.3-2.162,3.817,3.817,0,0,1,2.015,1.247,3.239,3.239,0,0,1,.442,2.881,4.956,4.956,0,0,1-1.758,2.407,10.808,10.808,0,0,1-2.66,1.425,22.673,22.673,0,0,1-7.124,1.758c-2.53.114-.888-3.307-.312-4.53a10.61,10.61,0,0,1,2.095-3.026",
    transform: "translate(-414.06 -165.895)",
    fill: "#4275e2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M569.146,229.3a18.106,18.106,0,0,0-3.6.994,8.755,8.755,0,0,0-2.939,2.155,21.315,21.315,0,0,0-2.268,2.931,15.51,15.51,0,0,0-1.682,3.409,11.142,11.142,0,0,0-.606,4.354c.012.166.272.167.26,0a12.362,12.362,0,0,1,2.006-7.24,21.451,21.451,0,0,1,2.172-2.936,9.178,9.178,0,0,1,2.774-2.258,15.835,15.835,0,0,1,3.948-1.159c.164-.033.094-.284-.069-.251",
    transform: "translate(-411.897 -169.252)",
    fill: "#0037a4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M548.31,297.206h-8.882l-1.576-14.527h12.034Z",
    transform: "translate(-397.002 -208.653)",
    fill: "#3e61d6"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 13.84,
    height: 3.4,
    transform: "translate(139.947 71.477)",
    fill: "#0044c3"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 16.752,
    height: 1.869,
    transform: "translate(126.227 51.908)",
    fill: "#002c82"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M499.731,248.976h-.568V206.55a1.717,1.717,0,0,0-1.715-1.715H486.326a1.717,1.717,0,0,0-1.715,1.715v42.426h-.568V206.55a2.285,2.285,0,0,1,2.283-2.283h11.123a2.286,2.286,0,0,1,2.283,2.283Z",
    transform: "translate(-357.284 -150.775)",
    fill: "#002c82"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 15.12,
    height: 0.568,
    transform: "translate(127.043 82.681)",
    fill: "#002c82"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 16.752,
    height: 1.869,
    transform: "translate(84.384 51.908)",
    fill: "#002c82"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M339.95,248.976h-.568V206.55a1.717,1.717,0,0,0-1.715-1.715H326.545a1.717,1.717,0,0,0-1.715,1.715v42.426h-.568V206.55a2.285,2.285,0,0,1,2.283-2.283h11.123a2.285,2.285,0,0,1,2.283,2.283Z",
    transform: "translate(-239.346 -150.775)",
    fill: "#002c82"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 15.12,
    height: 0.568,
    transform: "translate(85.2 82.681)",
    fill: "#002c82"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 16.752,
    height: 1.869,
    transform: "translate(0.702 51.908)",
    fill: "#002c82"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M20.4,248.976h-.568V206.55a1.717,1.717,0,0,0-1.715-1.715H7a1.717,1.717,0,0,0-1.715,1.715v42.426H4.713V206.55A2.285,2.285,0,0,1,7,204.267H18.118A2.286,2.286,0,0,1,20.4,206.55Z",
    transform: "translate(-3.479 -150.775)",
    fill: "#002c82"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 15.12,
    height: 0.568,
    transform: "translate(1.518 82.681)",
    fill: "#002c82"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 43.076,
    height: 1.85,
    transform: "translate(85.652 37.636)",
    fill: "#002c82"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M334.132,208.812l-.26-.115-.283-.019c.026-.582.008-41.31,0-53.778a5.2,5.2,0,0,1,5.2-5.2H366.3a5.205,5.205,0,0,1,5.2,5.2v53.8h-.568V154.9a4.636,4.636,0,0,0-4.631-4.631H338.79a4.631,4.631,0,0,0-4.631,4.633c0,6.978.01,20.436.012,32.168,0,6.487,0,11.6,0,15.183,0,6.486,0,6.486-.037,6.562",
    transform: "translate(-246.23 -110.496)",
    fill: "#002c82"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 37.11,
    height: 0.568,
    transform: "translate(87.875 79.817)",
    fill: "#002c82"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M97.135,176.72c1.1,10.386,2.726,47.255,2.726,47.255a5.6,5.6,0,0,0,3.965.04s4.226-35.519,3.8-47.3Z",
    transform: "translate(-71.698 -130.441)",
    fill: "#485e87"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M104.517,360.871l.012.087c.012.129.026.253.049.387.025.111.045.232.068.356l13.274.13a2.54,2.54,0,0,0,.025-.352,3.463,3.463,0,0,0-.033-.39.574.574,0,0,0-.018-.087,2.715,2.715,0,0,0-2.482-2.135,2.593,2.593,0,0,0-.278-.047h-.008c-.142-.022-.284-.037-.436-.052l-.15-.012a10.545,10.545,0,0,1-5.224-1.554,11.536,11.536,0,0,1-4.078-.04,5.16,5.16,0,0,0-.447,1.048c-.033.113-.068.233-.1.362-.008.024-.014.05-.022.079-.014.05-.025.108-.036.165a.363.363,0,0,0-.009.053c0,.013-.008.018-.008.029a6.393,6.393,0,0,0-.117.9,6.8,6.8,0,0,0,.018,1.077",
    transform: "translate(-77.123 -263.63)",
    fill: "#74dbff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M124.848,357.574a.24.24,0,0,0-.167-.071.275.275,0,0,0-.168.068l-.111.085q-.265.2-.538.387a.255.255,0,0,0-.111.141.243.243,0,0,0,.022.183.24.24,0,0,0,.324.088c.254-.174.5-.357.746-.546a.237.237,0,0,0,.071-.167.242.242,0,0,0-.068-.168",
    transform: "translate(-91.339 -263.881)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M128.317,359.226a.24.24,0,0,0-.335,0,4.022,4.022,0,0,1-.583.544c-.034.025-.068.05-.1.074a.255.255,0,0,0-.11.141.243.243,0,0,0,.022.183.24.24,0,0,0,.324.088,4.265,4.265,0,0,0,.782-.691.251.251,0,0,0,.071-.167.242.242,0,0,0-.068-.168",
    transform: "translate(-93.872 -265.102)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M132.136,360.427a.24.24,0,0,0-.167-.071.229.229,0,0,0-.168.068l-.545.687a.261.261,0,0,0-.071.167.243.243,0,0,0,.068.169.238.238,0,0,0,.167.071.226.226,0,0,0,.168-.068l.545-.687a.259.259,0,0,0,.071-.167.242.242,0,0,0-.068-.168",
    transform: "translate(-96.83 -265.987)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M136.429,361.429a.241.241,0,0,0-.326.084l-.357.6a.237.237,0,1,0,.4.254l.357-.6a.24.24,0,0,0-.074-.337",
    transform: "translate(-100.168 -266.756)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M104.645,371.662c.014.125.028.253.053.384.022.115.041.235.068.358l13.272.13a2.324,2.324,0,0,0,.026-.352,2.958,2.958,0,0,0-.034-.389Z",
    transform: "translate(-77.241 -274.333)",
    fill: "#4971e7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M25.344,360.871l-.012.087c-.012.129-.026.253-.049.387-.025.111-.045.232-.068.356l-13.274.13a2.54,2.54,0,0,1-.025-.352,3.461,3.461,0,0,1,.033-.39.574.574,0,0,1,.018-.087,2.715,2.715,0,0,1,2.482-2.135,2.594,2.594,0,0,1,.278-.047h.008c.142-.022.284-.037.436-.052l.15-.012a10.545,10.545,0,0,0,5.224-1.554,11.536,11.536,0,0,0,4.078-.04,5.159,5.159,0,0,1,.447,1.048c.033.113.068.233.1.362.008.024.014.05.022.079.014.05.025.108.036.165a.329.329,0,0,1,.008.053c0,.013.008.018.008.029a6.393,6.393,0,0,1,.117.9,6.8,6.8,0,0,1-.018,1.077",
    transform: "translate(-8.795 -263.63)",
    fill: "#74dbff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M39.647,357.574a.24.24,0,0,1,.167-.071.275.275,0,0,1,.168.068l.111.085q.265.2.538.387a.255.255,0,0,1,.111.141.243.243,0,0,1-.022.183.24.24,0,0,1-.324.088c-.254-.174-.5-.357-.746-.546a.237.237,0,0,1-.071-.167.242.242,0,0,1,.068-.168",
    transform: "translate(-29.214 -263.881)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M36.075,359.226a.24.24,0,0,1,.335,0,4.022,4.022,0,0,0,.583.544c.034.025.068.05.1.074a.257.257,0,0,1,.111.141.244.244,0,0,1-.022.183.24.24,0,0,1-.324.088,4.265,4.265,0,0,1-.782-.691.251.251,0,0,1-.071-.167.242.242,0,0,1,.068-.168",
    transform: "translate(-26.578 -265.102)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M32.788,360.427a.24.24,0,0,1,.167-.071.229.229,0,0,1,.168.068l.545.687a.261.261,0,0,1,.071.167.243.243,0,0,1-.068.169.238.238,0,0,1-.167.071.226.226,0,0,1-.168-.068l-.545-.687a.259.259,0,0,1-.071-.167.242.242,0,0,1,.068-.168",
    transform: "translate(-24.151 -265.987)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M29.007,361.429a.241.241,0,0,1,.339.108l.351.585a.237.237,0,1,1-.42.219l-.352-.586a.241.241,0,0,1,.082-.326",
    transform: "translate(-21.327 -266.757)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M25.33,371.662c-.014.125-.029.253-.053.384-.022.115-.041.235-.068.358l-13.272.13a2.341,2.341,0,0,1-.027-.352,3.051,3.051,0,0,1,.034-.389Z",
    transform: "translate(-8.792 -274.333)",
    fill: "#4971e7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M49.952,174.823c-3.08,14.211-5.086,47.79-5.086,47.79a10.873,10.873,0,0,0,4.078-.04s9.91-39.206,12.589-47.253Z",
    transform: "translate(-33.117 -129.041)",
    fill: "#485e87"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M65.146,174.448l-19.168-.806c-3.018,17.32-6.4,43.887-6.4,43.887a22.456,22.456,0,0,0,8.155,0l7.545-32.5.034,32.6a33.636,33.636,0,0,0,8.255-.148s2.075-37.437,1.578-43.032",
    transform: "translate(-29.215 -128.169)",
    fill: "#0037a4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M99,182.485q.061,1.728.1,3.456t.051,3.439q.007.966.008,1.932a.035.035,0,0,0,.07,0q0-1.728-.025-3.457t-.071-3.439q-.026-.966-.06-1.932c0-.045-.072-.045-.07,0",
    transform: "translate(-73.072 -134.672)",
    fill: "#002c82"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M95.474,182.248q-.007.944.027,1.887c.011.3.018.608.046.91a1.051,1.051,0,0,0,.267.682.789.789,0,0,0,.706.2c.044-.009.025-.077-.019-.068a.716.716,0,0,1-.618-.167.987.987,0,0,1-.268-.68c-.024-.287-.032-.575-.043-.863s-.019-.593-.024-.89q-.008-.507,0-1.014a.035.035,0,0,0-.07,0",
    transform: "translate(-70.471 -134.497)",
    fill: "#002c82"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M123.01,179.288a3.223,3.223,0,0,0,.474,1.955,3.195,3.195,0,0,0,2.628,1.487.035.035,0,0,0,0-.07,3.156,3.156,0,0,1-1.827-.64,3.123,3.123,0,0,1-1.2-2.732c0-.045-.067-.045-.07,0",
    transform: "translate(-90.789 -132.312)",
    fill: "#002c82"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M125.845,191.543q-.145,7.867-.464,15.73t-.811,15.716q-.277,4.408-.607,8.811c0,.045.067.045.07,0q.589-7.846,1.006-15.7t.659-15.723q.136-4.414.217-8.829a.035.035,0,0,0-.07,0",
    transform: "translate(-91.5 -141.358)",
    fill: "#002c82"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M62.033,236.886l1.976-7.338L66,222.174l1.976-7.338q.976-3.623,1.891-7.262t1.774-7.322q.105-.452.21-.9c.01-.044-.058-.063-.068-.019q-.847,3.655-1.752,7.3t-1.882,7.3q-.98,3.667-1.974,7.331l-1.976,7.338-1.986,7.374-.244.9a.035.035,0,0,0,.068.019",
    transform: "translate(-45.737 -147.111)",
    fill: "#002c82"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M60.09,267.563a6.12,6.12,0,0,0,3.436-.589c.041-.02,0-.081-.036-.061a6.072,6.072,0,0,1-2.634.623,6,6,0,0,1-.766-.043c-.045-.005-.045.065,0,.07",
    transform: "translate(-44.329 -197.012)",
    fill: "#002c82"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M106.856,267.156a3.037,3.037,0,0,0,2.41-.069,2.876,2.876,0,0,0,.587-.366c.035-.029-.015-.078-.05-.05a2.962,2.962,0,0,1-2.277.6,2.826,2.826,0,0,1-.651-.181c-.042-.017-.06.051-.019.068",
    transform: "translate(-78.856 -196.831)",
    fill: "#002c82"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M82.908,94.332c-2.855,1.264-17.523,1.833-19.264-.31l3.237-16.6.131-.674.23-1.181.13-.666,1.7-8.731,3.75-1.073,3.668.125,3.816,1.128q.638,4.826,1.079,8.737c.025.219.049.436.074.651l.119,1.079c.024.22.048.438.071.653,1.28,11.875,1.256,16.857,1.256,16.857",
    transform: "translate(-46.977 -48.053)",
    fill: "#7187ff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M92.445,102.4a14.859,14.859,0,0,1-5.848.437c-2.433-.273-4.858-.872-7.316-.71l-.035.028a3.426,3.426,0,0,0-.361.356q-.1.11-.182.227a.659.659,0,0,1-.08.1,15.347,15.347,0,0,1,3.749.048c2.75.327,5.453.977,8.234.583a13.679,13.679,0,0,0,1.912-.413c-.025-.215-.049-.432-.074-.651",
    transform: "translate(-58.034 -75.365)",
    fill: "#3e61d6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M90.774,109.826a13.666,13.666,0,0,1-2.1.47c-2.781.393-5.484-.256-8.234-.584a14.091,14.091,0,0,0-4.435.065l.131-.674c.215-.039.432-.07.649-.1,2.651-.307,5.26.366,7.879.66a14.764,14.764,0,0,0,6.041-.5q.036.33.071.653",
    transform: "translate(-56.099 -80.404)",
    fill: "#3e61d6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M88.416,97.109a1.354,1.354,0,0,0,1.478,1.146,1.962,1.962,0,0,0,3.687-.933V95.738H89.658v.307c-.674-.09-1.348.285-1.242,1.065m1.213-.53.029,0v.739a1.959,1.959,0,0,0,.041.4.8.8,0,0,1-.688-.458c-.23-.5.143-.786.618-.686",
    transform: "translate(-65.254 -70.667)",
    fill: "#9be4ff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M90.606,96.78c.6-.017.244,1.412.244,1.412.615.008,2.12-1.327,2.327-1.49.355-.279.7.191.461.611.277.038.383.437.193.738.5.22.118.768.118.768.337.13.2.622.083.813A3.965,3.965,0,0,1,92,101.361a6.513,6.513,0,0,1-1.365.373L88.888,99c.438-.262,1.263-2.207,1.718-2.219",
    transform: "translate(-65.61 -71.317)",
    fill: "#485e87"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M54.144,69.2C49.221,70.521,44.4,79.364,43.492,83.8c-.52,2.546,1.7,3.863,3.7,3.863,2.756,0,10.153-5.572,10.2-6.172.079-.972-1.317-3.1-2.244-3.05-.851.048-5.286,3.069-5.286,3.069L52.251,78.9Z",
    transform: "translate(-32.046 -51.077)",
    fill: "#7187ff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M67.572,104.062c-.569.263-1.137.528-1.692.818q-.766.4-1.5.85t-1.449.955q-.7.5-1.369,1.041t-1.3,1.136l-.16.151c-.033.031.017.081.05.05q.626-.6,1.291-1.147t1.372-1.06q.7-.5,1.428-.957t1.5-.862c.544-.289,1.1-.555,1.658-.814l.215-.1c.041-.019.005-.08-.036-.061",
    transform: "translate(-44.351 -76.808)",
    fill: "#0044c3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M67.755,104.86l1.542-1.693c.488-.535.973-1.073,1.483-1.587.286-.288.581-.568.888-.834.034-.03-.016-.08-.05-.05a20.112,20.112,0,0,0-1.535,1.509c-.507.544-1,1.1-1.506,1.647l-.873.958c-.031.033.019.083.05.05",
    transform: "translate(-49.968 -74.32)",
    fill: "#0044c3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M81.339,101.794l-.83.234a.035.035,0,0,0,.019.068l.83-.234a.035.035,0,0,0-.019-.068",
    transform: "translate(-59.408 -75.135)",
    fill: "#0044c3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M75.764,116.349a8.043,8.043,0,0,1-1.132,1.184,13.969,13.969,0,0,1-1.306.986c-.453.307-.916.6-1.379.889-.529.334-1.056.671-1.585,1l-1.652,1.037-.209.131c-.038.024,0,.085.036.061q.832-.525,1.667-1.046.814-.511,1.625-1.028c.466-.295.934-.586,1.392-.891a15.331,15.331,0,0,0,1.321-.974,8.426,8.426,0,0,0,1.158-1.159c.042-.052.084-.105.125-.158.028-.036-.034-.071-.061-.036",
    transform: "translate(-50.551 -85.869)",
    fill: "#0044c3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M90.574,18.5a6.225,6.225,0,0,1-2.143-2.168,2.557,2.557,0,0,1,.253-2.876.552.552,0,1,1-.03-1.075,6.068,6.068,0,0,1,4.094-4.958,3.965,3.965,0,0,1,3.449.346,5.38,5.38,0,0,1,1.652-.443,2.573,2.573,0,0,1,1.682.453,1.992,1.992,0,0,1,.333,2.866,2.422,2.422,0,0,1-.761,4.276,3.76,3.76,0,0,1-1.733,2.264,10.114,10.114,0,0,1-2.711,1.079,11.512,11.512,0,0,1-2,.428,3.251,3.251,0,0,1-2.088-.194",
    transform: "translate(-64.947 -5.307)",
    fill: "#241f5d"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M94.924,22.905a16.9,16.9,0,0,1,.908,6.6,1.961,1.961,0,0,0,3.612.181,3.342,3.342,0,0,1,.852-2.513c.04-.038.08-.071.122-.107s.057-.048.089-.072c.056-.045.121-.085.182-.131.087-.059.177-.117.271-.176h0a14.842,14.842,0,0,0,1.287-.849A4.211,4.211,0,0,0,103.8,23.28a.35.35,0,0,0,.012-.046c.006-.018.009-.037.013-.055s.013-.063.018-.1c0-.015.007-.028.01-.042a16.428,16.428,0,0,0-.068-5.2c-.328-2.4-6.017-3.709-7.8-.8-.735,1.2-1.061,5.864-1.061,5.864",
    transform: "translate(-70.066 -11.346)",
    fill: "#485e87"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M103.139,16.066a4.116,4.116,0,0,0-2.115-1.977,8.192,8.192,0,0,0-3.428-.358,3.944,3.944,0,0,0-1.824.365,3.025,3.025,0,0,0-1.028,1.093,6.577,6.577,0,0,0-.632,5.385l-.192.147a2,2,0,0,0,1.5-2.1,2.618,2.618,0,0,0,1.729-2.152.679.679,0,0,0,.668-.169,4.3,4.3,0,0,0,4.014.169,1.611,1.611,0,0,0,1.031.831,1.908,1.908,0,0,0,.571,1.663,4.171,4.171,0,0,0-.291-2.9",
    transform: "translate(-69.236 -10.117)",
    fill: "#241f5d"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M118.584,42.191a.666.666,0,0,1,.27-.052.377.377,0,0,1,.239.075.3.3,0,0,1,.1.236.551.551,0,0,1-.073.244.089.089,0,0,1-.111.053.088.088,0,0,1-.053-.111.489.489,0,0,0,.063-.178.157.157,0,0,0-.021-.093l0,.005a.117.117,0,0,0-.078-.05l-.008,0-.02,0-.052,0H118.8a.95.95,0,0,0-.155.038.087.087,0,0,1-.1-.044.088.088,0,0,1,.039-.117",
    transform: "translate(-87.495 -31.103)",
    fill: "#4d4d5d"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M122.122,33.845a1.583,1.583,0,0,0-1.473-.147.249.249,0,0,0-.139.319.263.263,0,0,0,.367.12,1.208,1.208,0,0,1,.406-.071c0-.008-.013,0,0,0a1.1,1.1,0,0,1,.5.139l.033.019a.252.252,0,0,0,.344-.037.249.249,0,0,0-.036-.346",
    transform: "translate(-88.938 -24.786)",
    fill: "#241f5d"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M110.88,33.3a1.583,1.583,0,0,0-1.479.036.246.246,0,1,0,.235.432c.046-.026.093-.048.141-.071l.007,0,.026-.009.056-.018a1.346,1.346,0,0,1,.154-.034c.013,0,.1-.02.032-.005a.379.379,0,0,1,.069,0,1.323,1.323,0,0,1,.148,0l.079.008h.006l.016,0a1.336,1.336,0,0,1,.143.038l.074.027.029.012,0,0h0a.246.246,0,0,0,.258-.418",
    transform: "translate(-80.656 -24.456)",
    fill: "#241f5d"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M115.067,46.265c.115-.139.355.049.659.11s.6-.022.651.151c.067.219-.293.657-.792.558s-.664-.643-.518-.819",
    transform: "translate(-84.896 -34.112)",
    fill: "#394bc0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M115.125,47.685a2.434,2.434,0,0,1,.308.041,1.524,1.524,0,0,1,.764.337.7.7,0,0,1-.532.107.707.707,0,0,1-.54-.484",
    transform: "translate(-84.977 -35.197)",
    fill: "#6a7ae6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M116.061,46.546c-.272-.054-.49-.165-.545-.328.13-.024.333.108.579.157s.485,0,.6.077a.682.682,0,0,1-.629.094",
    transform: "translate(-85.265 -34.112)",
    fill: "#97fcff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M123.341,39.5a.385.385,0,1,1-.385-.385.385.385,0,0,1,.385.385",
    transform: "translate(-90.473 -28.87)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M124.454,39.758a.111.111,0,1,1-.111-.111.111.111,0,0,1,.111.111",
    transform: "translate(-91.699 -29.264)",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M112.177,38.39a.385.385,0,1,1-.385-.385.385.385,0,0,1,.385.385",
    transform: "translate(-82.232 -28.052)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M113.291,38.65a.111.111,0,1,1-.111-.111.111.111,0,0,1,.111.111",
    transform: "translate(-83.459 -28.447)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M89.153,38.789a1.132,1.132,0,1,0,.041-1.773,1.271,1.271,0,0,0-.041,1.773",
    transform: "translate(-65.558 -27.186)",
    fill: "#485e87"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M90.471,38.516a.851.851,0,0,1,.746.052.694.694,0,0,1,.274.236.423.423,0,0,1,.041.392.6.6,0,0,1-.217.231.573.573,0,0,0-.145.132.217.217,0,0,0,.263.319.1.1,0,1,1,.072.179.4.4,0,0,1-.169.028.407.407,0,0,1-.326-.631.73.73,0,0,1,.192-.182.446.446,0,0,0,.155-.154.233.233,0,0,0-.028-.211.194.194,0,0,0-.349,0,.344.344,0,0,0-.1.278.1.1,0,0,1-.085.107h-.016a.1.1,0,0,1-.091-.085.534.534,0,0,1,.154-.436.436.436,0,0,1,.149-.091.606.606,0,0,0-.439.008.373.373,0,0,0-.209.443.1.1,0,1,1-.179.072.563.563,0,0,1,.306-.69",
    transform: "translate(-66.529 -28.382)",
    fill: "#4d4d5d"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M85.81,124.942l4.057-.181.236-6.108-5.071.226Z",
    transform: "translate(-62.764 -87.581)",
    fill: "#9be4ff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M99.792,121.021l1.787-.119.252-.017a.145.145,0,0,1,.166.153q-.03.68-.061,1.36l-.1,2.168q-.011.249-.022.5a.142.142,0,0,1-.117.126l-1.777.082-.253.012a.147.147,0,0,1-.165-.115.143.143,0,0,1,.115-.165l1.777-.082.253-.012-.117.126q.03-.68.061-1.359l.1-2.168q.011-.249.022-.5l.166.153-1.787.119-.252.016a.146.146,0,0,1-.165-.115.143.143,0,0,1,.115-.165",
    transform: "translate(-73.447 -89.228)",
    fill: "#9be4ff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M81.79,119.516l-1.15.051,1.333,1.377Z",
    transform: "translate(-59.522 -88.218)",
    fill: "#9be4ff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M87.574,143.507l4.4-.2-.232-1.332-4.057.181Z",
    transform: "translate(-64.641 -104.798)",
    fill: "#3e61d6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M102.612,119.145c-.524.3.534,1.33.534,1.33-.519.33-2.5-.015-2.762-.045-.448-.051-.492.529-.071.762-.216.178-.1.573.223.729-.309.45.3.715.3.715-.218.288.157.634.356.736a3.967,3.967,0,0,0,2.638.4,6.513,6.513,0,0,0,1.358-.4l.049-3.245c-.511.008-2.234-1.214-2.628-.986",
    transform: "translate(-73.828 -87.923)",
    fill: "#485e87"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M120.45,69.886c4.62,1.827,10.085,8.9,11.4,10.384,2.32,2.611,1.148,5.983-.52,6.563-1.445.5-12.268,1.063-12.739.508-.641-.757-.795-3.2-.157-3.964.314-.375,8.013-.858,8.013-.858L121.56,78.94Z",
    transform: "translate(-87.118 -51.585)",
    fill: "#7187ff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M119.567,118.937q1.835-.326,3.692-.51t3.711-.222q1.046-.022,2.093,0a.035.035,0,0,0,0-.07q-1.868-.042-3.736.061t-3.72.351q-1.033.138-2.059.321c-.045.008-.026.076.019.068",
    transform: "translate(-88.223 -87.19)",
    fill: "#0044c3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M128.46,101.913c.743.542,1.475,1.1,2.208,1.657l2.212,1.684,1.254.955c.036.028.071-.034.036-.061l-2.226-1.695c-.733-.558-1.465-1.118-2.2-1.673q-.62-.468-1.247-.927c-.037-.027-.072.034-.036.061",
    transform: "translate(-94.808 -75.175)",
    fill: "#0044c3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M120.864,136.778a19.185,19.185,0,0,0,2.917.225q.414,0,.828-.018c.045,0,.045-.072,0-.07a19.127,19.127,0,0,1-2.906-.1q-.411-.045-.82-.108c-.045-.007-.064.061-.019.068",
    transform: "translate(-89.194 -100.909)",
    fill: "#0044c3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(21.889 14.98)",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M87.111,64.848a1.033,1.033,0,0,0-.535-1.171,5.029,5.029,0,0,0-1.33-.418,2.5,2.5,0,0,1-1.353-.783A1.272,1.272,0,0,1,83.771,61a1.5,1.5,0,0,1,1.136-.538c.431-.034.866.028,1.3,0a1.863,1.863,0,0,0,1.612-.978,5.957,5.957,0,0,0,.222-.952,1.74,1.74,0,0,1,1.117-1.28,1.153,1.153,0,0,1,1.42.722,1.632,1.632,0,0,1-.612,1.464,5.2,5.2,0,0,1-1.789,1.146c-.208.079-.456.183-.493.4a.421.421,0,0,0,.251.415,1.382,1.382,0,0,0,.506.1,7.45,7.45,0,0,1,3.373,1.168,1.558,1.558,0,0,1,.837,1.1,1.091,1.091,0,0,1-.585.958,2.169,2.169,0,0,1-1.145.226c-.394-.013-.785-.079-1.179-.089a1.3,1.3,0,0,0-.574.088.557.557,0,0,0-.341.442c-.014.207.122.394.151.6.118.828-1.215,1.034-1.8,1.08A.857.857,0,0,1,86.3,65.8c.2-.377.659-.547.815-.953",
    transform: "translate(-83.586 -57.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M89.785,81.707a.94.94,0,0,1,.322.661.7.7,0,0,1-.35.627.555.555,0,0,1-.681-.137c-.245-.255,0-.743-.234-1.006-.068-.076-.175-.133-.185-.234-.021-.213.343-.247.489-.228a1.281,1.281,0,0,1,.638.317",
    transform: "translate(-87.329 -75.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M102.476,69.291a.833.833,0,0,0-.287.188.357.357,0,0,0-.094.318.368.368,0,0,0,.248.238,1.068,1.068,0,0,0,.355.037,2.476,2.476,0,0,0,.6-.055.857.857,0,0,0,.5-.322c.158-.231.153-.6-.173-.627a2.451,2.451,0,0,0-1.151.223",
    transform: "translate(-97.241 -65.957)",
    fill: "#fff"
  }))))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M427.574,360.682l-.013.088c-.012.131-.027.256-.049.393-.026.112-.046.235-.069.361l-13.452.132a2.576,2.576,0,0,1-.025-.357,3.507,3.507,0,0,1,.034-.4.557.557,0,0,1,.018-.088,3.454,3.454,0,0,1,2.8-2.212h.008c.144-.023.288-.038.442-.052l.152-.012a10.684,10.684,0,0,0,5.294-1.575,11.69,11.69,0,0,0,4.133-.04,5.229,5.229,0,0,1,.453,1.062c.033.114.069.237.1.367.008.024.014.051.022.08.014.051.025.109.036.168a.424.424,0,0,1,.008.053c0,.013.008.019.008.029a6.475,6.475,0,0,1,.118.908,6.887,6.887,0,0,1-.019,1.091",
    transform: "translate(-305.558 -263.454)",
    fill: "#4275e2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M442.069,357.342a.24.24,0,0,1,.169-.072.278.278,0,0,1,.171.069c.088.068.177.135.265.2.125.1.261.184.392.274a.259.259,0,0,1,.112.143.241.241,0,0,1-.35.275c-.258-.176-.509-.361-.756-.553a.24.24,0,0,1-.072-.169.244.244,0,0,1,.069-.171",
    transform: "translate(-326.251 -263.709)",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M438.449,359.016a.243.243,0,0,1,.34,0,4.076,4.076,0,0,0,.591.551c.035.025.069.051.1.075a.258.258,0,0,1,.112.142.24.24,0,0,1-.35.275,4.313,4.313,0,0,1-.793-.7.254.254,0,0,1-.072-.169.244.244,0,0,1,.069-.171",
    transform: "translate(-323.579 -264.946)",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M435.117,360.233a.242.242,0,0,1,.169-.072.231.231,0,0,1,.17.069l.552.7a.263.263,0,0,1,.072.169.246.246,0,0,1-.069.171.241.241,0,0,1-.169.072.231.231,0,0,1-.171-.069l-.552-.7a.262.262,0,0,1-.072-.169.245.245,0,0,1,.069-.171",
    transform: "translate(-321.12 -265.843)",
    fill: "#fff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M431.285,361.248a.248.248,0,0,1,.369.249l.222.364a.236.236,0,0,1,.026.42.248.248,0,0,1-.369-.248l-.223-.366a.236.236,0,0,1-.026-.419",
    transform: "translate(-318.257 -266.622)",
    fill: "#fff"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M427.559,371.618c-.014.127-.029.257-.053.389-.022.117-.042.239-.069.363l-13.449.132a2.331,2.331,0,0,1-.027-.357,3.006,3.006,0,0,1,.035-.394Z",
    transform: "translate(-305.555 -274.3)",
    fill: "#4971e7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M507.761,360.682l.013.088c.012.131.027.256.049.393.025.112.046.235.068.361l13.452.132a2.57,2.57,0,0,0,.025-.357,3.516,3.516,0,0,0-.034-.4.547.547,0,0,0-.018-.088,3.454,3.454,0,0,0-2.8-2.212h-.008c-.144-.023-.287-.038-.442-.052l-.152-.012a10.683,10.683,0,0,1-5.294-1.575,11.692,11.692,0,0,1-4.133-.04,5.227,5.227,0,0,0-.453,1.062c-.033.114-.069.237-.1.367-.008.024-.014.051-.022.08-.014.051-.025.109-.036.168a.363.363,0,0,0-.009.053c0,.013-.008.019-.008.029a6.511,6.511,0,0,0-.118.908,6.886,6.886,0,0,0,.019,1.091",
    transform: "translate(-374.767 -263.454)",
    fill: "#4275e2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M528.365,357.342a.241.241,0,0,0-.169-.072.278.278,0,0,0-.17.069c-.088.068-.177.135-.265.2-.125.1-.261.184-.392.274a.26.26,0,0,0-.112.143.246.246,0,0,0,.022.185.243.243,0,0,0,.328.09c.258-.176.509-.361.756-.553a.24.24,0,0,0,.072-.169.245.245,0,0,0-.069-.171",
    transform: "translate(-389.174 -263.709)",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M531.88,359.016a.244.244,0,0,0-.34,0,4.077,4.077,0,0,1-.591.551c-.034.025-.069.051-.1.075a.258.258,0,0,0-.112.142.24.24,0,0,0,.35.275,4.312,4.312,0,0,0,.793-.7.255.255,0,0,0,.072-.169.245.245,0,0,0-.069-.171",
    transform: "translate(-391.741 -264.946)",
    fill: "#fff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M535.749,360.233a.242.242,0,0,0-.169-.072.231.231,0,0,0-.171.069l-.552.7a.263.263,0,0,0-.072.169.244.244,0,0,0,.069.171.241.241,0,0,0,.169.072.231.231,0,0,0,.171-.069l.552-.7a.262.262,0,0,0,.072-.169.244.244,0,0,0-.069-.171",
    transform: "translate(-394.738 -265.843)",
    fill: "#fff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M540.1,361.247a.249.249,0,0,0-.369.25l-.228.366a.236.236,0,0,0-.02.417.248.248,0,0,0,.369-.25l.228-.366a.236.236,0,0,0,.02-.417",
    transform: "translate(-398.12 -266.622)",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M507.891,371.618c.014.127.029.257.053.389.022.117.042.239.069.363l13.449.132a2.326,2.326,0,0,0,.027-.357,3,3,0,0,0-.035-.394Z",
    transform: "translate(-374.887 -274.3)",
    fill: "#4971e7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M503.337,172.932c.246,18.364-2.978,48.224-2.978,48.224a12.847,12.847,0,0,1-4.133-.041c-2.493-28.97-5.113-48.183-5.113-48.183Z",
    transform: "translate(-362.503 -127.645)",
    fill: "#afc5e5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M451.3,172.932a314.785,314.785,0,0,0-3.946,48.224,10.264,10.264,0,0,0,4.133-.041,348.992,348.992,0,0,1,11.677-48.183Z",
    transform: "translate(-330.2 -127.645)",
    fill: "#afc5e5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M449.207,194.561s4.465.463,8.044.437h.071a20.3,20.3,0,0,0,2.715-.171l.13-1,.009-.071.064-.49.009-.072.875-6.731.787,6.622.008.071.06.507.009.072.127,1.068s6.416.413,9.78.171l.071-.006a9.414,9.414,0,0,0,1.269-.165s0-.366.008-1.016v-.07q0-.229,0-.5v-.071c.007-3.784-.061-13.264-.839-20.212H452.669c-.977,3.337-2.61,15.208-3.222,19.8,0,.024-.005.046-.009.07-.022.168-.042.324-.062.471,0,.023-.006.047-.009.07-.1.77-.159,1.219-.159,1.219",
    transform: "translate(-331.571 -127.646)",
    fill: "#0044c3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M490.084,180.456q.253,2.173.506,4.347l.5,4.325.285,2.449c.005.045-.065.045-.07,0l-.506-4.347-.5-4.325-.285-2.449c-.005-.045.065-.045.07,0",
    transform: "translate(-361.691 -133.174)",
    fill: "#002c82"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M484.845,180l.4,2.865c.063.46.119.922.194,1.379a2.827,2.827,0,0,0,.41,1.179,1.292,1.292,0,0,0,1.015.6.035.035,0,0,1,0,.07,1.3,1.3,0,0,1-.946-.467,2.356,2.356,0,0,1-.5-1.111c-.045-.216-.075-.435-.105-.654q-.05-.365-.1-.73l-.2-1.459-.228-1.653c-.006-.044.062-.063.068-.019",
    transform: "translate(-357.825 -132.844)",
    fill: "#002c82"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M530.314,172.007c0,.073.009.145.014.217l.311,4.788q.291,4.46.581,8.919.215,3.308.43,6.618c0,.024,0,.047.005.07q.016.249.032.5c0,.023,0,.047.005.07q.035.538.07,1.076l.071-.006q-.035-.538-.07-1.075c0-.023,0-.047,0-.07-.01-.166-.022-.332-.033-.5,0-.023,0-.047,0-.07q-.088-1.35-.176-2.7-.291-4.46-.581-8.919-.282-4.35-.566-8.7c0-.073-.009-.145-.014-.217,0-.046-.074-.046-.07,0",
    transform: "translate(-391.437 -126.937)",
    fill: "#002c82"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M479.923,216.554h.071l.168-1c0-.023.008-.047.012-.07l.081-.486c0-.023.008-.047.012-.071q.066-.393.131-.785.5-2.989,1-5.979t1-5.979c.007-.045-.061-.063-.068-.018l-.56,3.351q-.5,2.99-1,5.979-.288,1.717-.574,3.433h0c0,.024-.008.047-.012.07q-.042.243-.081.486h0c0,.024-.008.048-.011.071q-.084.5-.168,1",
    transform: "translate(-354.243 -149.203)",
    fill: "#002c82"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M497.979,252.093l.009.072q1.062.105,2.126.173,2.545.161,5.1.1,1.309-.029,2.616-.115l.07,0q.674-.046,1.347-.107v-.07q-.675.061-1.351.107l-.071,0-.347.022q-2.545.152-5.1.088-2.2-.055-4.4-.275",
    transform: "translate(-367.571 -186.076)",
    fill: "#002c82"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M497.719,249.885l.009.071q1.095.111,2.194.18,2.545.161,5.1.105,1.291-.029,2.579-.113l.07,0q.693-.047,1.385-.109v-.071q-.694.063-1.39.109l-.071,0-.31.02q-2.545.152-5.1.088-2.238-.057-4.466-.281",
    transform: "translate(-367.379 -184.446)",
    fill: "#002c82"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M449.814,250.666q.44.084.883.157,1.287.213,2.586.338t2.62.161q.982.027,1.964,0l.071,0q.3-.007.6-.02,1.04-.045,2.076-.148l.009-.071q-1.2.119-2.4.16l-.27.009h-.072q-1.142.03-2.283-.01-1.3-.045-2.6-.18t-2.615-.364c-.184-.032-.368-.066-.552-.1,0,.023-.005.047-.009.07",
    transform: "translate(-332.019 -184.971)",
    fill: "#002c82"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M450.088,248.6q.4.077.811.144,1.287.213,2.586.338t2.62.161q1.029.027,2.057,0l.071,0q.255-.007.509-.018,1.076-.047,2.149-.155L460.9,249q-1.235.126-2.478.168l-.177.006-.071,0h0q-1.187.034-2.376-.008-1.3-.044-2.6-.179t-2.615-.365q-.241-.042-.48-.087c0,.024-.005.046-.009.07",
    transform: "translate(-332.221 -183.448)",
    fill: "#002c82"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M408.106,126.467c-.218-.207-.574-.053-.96-.36s-.7-1.1-1.057-1.247-3.149-.6-3.2.029c-.031.373,1.525.545,1.545.582s-1.949.032-1.937.551,2.27.228,2.286.281-1.72.42-1.6.893,1.771-.053,1.8-.013-1.193.816-1.042,1.126,1.691-.573,1.74-.512a2.892,2.892,0,0,0,.717,1.173,1.79,1.79,0,0,0,1.98-.219,3.538,3.538,0,0,0-.277-2.283",
    transform: "translate(-297.091 -91.944)",
    fill: "#afc5e5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M435.139,66.961c-2.907.608-4.366,13-4.366,13l-10.792,3.018a6.291,6.291,0,0,0,.575,3.855s9.857-2.184,12.4-2.812,3.551-3.626,3.407-5.947-1.22-11.113-1.22-11.113",
    transform: "translate(-309.925 -49.426)",
    fill: "#3e61d6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M477.715,63.168l-3.205-.774-.714-.172-3.719.062-3.728,1.179-4.185,28.231c2.841,1.666,17.8.844,19.805-.48,0,0-1.532-13.782-4.253-28.046",
    transform: "translate(-341.134 -45.928)",
    fill: "#7187ff"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M480.337,94.185c0,3.144,1.44,5.693,3.217,5.693s3.217-2.549,3.217-5.693-1.44-5.693-3.217-5.693-3.217,2.549-3.217,5.693",
    transform: "translate(-354.549 -65.318)",
    fill: "#0044c3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M464.7,113.492h3.634l.28-5.031h-4.193Z",
    transform: "translate(-342.798 -80.057)",
    fill: "#4275e2"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 4.589,
    height: 0.769,
    transform: "translate(121.421 27.914)",
    fill: "#0044c3"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 3.377,
    height: 0.443,
    transform: "translate(122.027 27.471)",
    fill: "#0037a4"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M465.19,114.632c-.51.2.3,1.265.3,1.265-.51.225-2.239-.353-2.47-.415-.395-.106-.512.407-.167.673-.217.13-.164.5.1.684-.338.361.174.682.174.682-.235.228.054.59.219.708a3.6,3.6,0,0,0,2.31.719,5.911,5.911,0,0,0,1.271-.174l.484-2.9c-.459-.063-1.838-1.391-2.221-1.24",
    transform: "translate(-341.491 -84.604)",
    fill: "#afc5e5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M489.761,65.754c3.532.711,5.2,12.38,5.657,15.363.422,2.765-1.4,4.246-3.235,4.028-1.71-.2-13.529-2.08-13.529-2.08s-.207-3.062.609-4.114L489.8,80.01s-1.695-6.371-2.226-8.746c-1.4-6.261,2.183-5.511,2.183-5.511",
    transform: "translate(-353.288 -48.514)",
    fill: "#3e61d6"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M476.616,5.185a3.013,3.013,0,0,1,.41-2.54,3.984,3.984,0,0,1,2.117-1.529A5.929,5.929,0,0,1,481.776.95a6.645,6.645,0,0,1,3.9,1.943,5.049,5.049,0,0,1,1.35,4.072,2.312,2.312,0,0,1,.678,1.179,3.51,3.51,0,0,1,.032,1.372,4.824,4.824,0,0,1-3.108,3.721L476.712,10.3a6.188,6.188,0,0,1-.1-5.117",
    transform: "translate(-351.429 -0.647)",
    fill: "#241f5d"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M487.214,17.684a17.126,17.126,0,0,0-1.528,6.579,1.987,1.987,0,0,1-3.662-.152A3.388,3.388,0,0,0,481.4,21.5c-.037-.042-.074-.079-.113-.12a1.155,1.155,0,0,0-.082-.081c-.053-.05-.114-.1-.172-.149-.083-.067-.168-.134-.257-.2h0a15.036,15.036,0,0,1-1.22-.976,4.267,4.267,0,0,1-1.331-2.728.376.376,0,0,1-.008-.048c0-.019-.006-.038-.008-.057,0-.034-.007-.065-.009-.1a.386.386,0,0,1-.006-.043,16.64,16.64,0,0,1,.551-5.245c.553-2.393,6.415-3.185,7.947-.081.63,1.282.527,6.016.527,6.016",
    transform: "translate(-352.931 -7.111)",
    fill: "#afc5e5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M479.577,9.9a8.783,8.783,0,0,0,4.529.3l-.472.273a9.206,9.206,0,0,0,3.056.092,6.565,6.565,0,0,0,1.686,4.547l.042-.107a8.594,8.594,0,0,0,.12-5.1,3.388,3.388,0,0,0-1.324-2.148,3.7,3.7,0,0,0-1.6-.433,17.138,17.138,0,0,0-2.716-.051,4.886,4.886,0,0,0-2.286.576A2.146,2.146,0,0,0,479.577,9.9",
    transform: "translate(-353.97 -5.341)",
    fill: "#241f5d"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M487.128,36.128a.674.674,0,0,0-.267-.078.384.384,0,0,0-.248.054.306.306,0,0,0-.123.229.563.563,0,0,0,.051.253.091.091,0,0,0,.107.064.089.089,0,0,0,.064-.107.487.487,0,0,1-.047-.185.158.158,0,0,1,.029-.092l0,0a.118.118,0,0,1,.084-.043h.081l.027,0h.012a.951.951,0,0,1,.153.053.088.088,0,0,0,.108-.035.089.089,0,0,0-.029-.122",
    transform: "translate(-359.089 -26.609)",
    fill: "#6a7ae6"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M481.274,27.252a1.605,1.605,0,0,1,1.5-.013.253.253,0,0,1,.111.335.267.267,0,0,1-.382.087,1.222,1.222,0,0,0-.4-.109c0-.008.012.006,0,.006a1.112,1.112,0,0,0-.52.094l-.035.016a.249.249,0,0,1-.275-.415",
    transform: "translate(-355.161 -19.973)",
    fill: "#241f5d"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M492.683,27.7a1.6,1.6,0,0,1,1.49.173.249.249,0,1,1-.278.414c-.044-.031-.09-.058-.136-.084l-.006,0-.025-.012-.055-.023a1.354,1.354,0,0,0-.152-.049c-.013,0-.1-.029-.032-.008a.38.38,0,0,0-.069-.01,1.357,1.357,0,0,0-.15-.011h-.086l-.017,0a1.336,1.336,0,0,0-.147.025l-.077.02-.03.01H492.9a.255.255,0,0,1-.332-.111.252.252,0,0,1,.11-.335",
    transform: "translate(-363.563 -20.368)",
    fill: "#241f5d"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M488.894,40.956a1.607,1.607,0,0,1-1.12.3c-.109-.012-.121.159-.012.17a1.784,1.784,0,0,0,1.244-.345c.088-.066-.025-.194-.113-.129",
    transform: "translate(-359.973 -30.218)",
    fill: "#6a7ae6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M494.425,33.4a.4.4,0,1,1-.412-.394.4.4,0,0,1,.412.394",
    transform: "translate(-364.352 -24.359)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M494.4,33.727a.118.118,0,1,1-.12-.115.118.118,0,0,1,.12.115",
    transform: "translate(-364.752 -24.81)",
    fill: "#fff"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M483.191,32.957a.4.4,0,1,1-.412-.394.4.4,0,0,1,.412.394",
    transform: "translate(-356.06 -24.035)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M483.161,33.288a.118.118,0,1,1-.12-.115.118.118,0,0,1,.12.115",
    transform: "translate(-356.46 -24.486)",
    fill: "#fff"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M511.757,35.246a1.147,1.147,0,1,1,.123-1.793,1.288,1.288,0,0,1-.123,1.793",
    transform: "translate(-376.203 -24.513)",
    fill: "#afc5e5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M513.314,34.932a.862.862,0,0,0-.757-.017.7.7,0,0,0-.3.213.428.428,0,0,0-.078.392.609.609,0,0,0,.2.254.584.584,0,0,1,.134.146.219.219,0,0,1-.294.3.1.1,0,0,0-.089.174.4.4,0,0,0,.168.044.413.413,0,0,0,.388-.606.742.742,0,0,0-.177-.2.455.455,0,0,1-.142-.17.237.237,0,0,1,.048-.21.2.2,0,0,1,.353.036.35.35,0,0,1,.073.289.1.1,0,0,0,.076.115l.016,0a.1.1,0,0,0,.1-.078.54.54,0,0,0-.114-.455.439.439,0,0,0-.142-.106.615.615,0,0,1,.443.049.378.378,0,0,1,.17.466.1.1,0,1,0,.174.089.571.571,0,0,0-.245-.724",
    transform: "translate(-377.975 -25.714)",
    fill: "#6a7ae6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M304.641,147.926c1.852,7.146,5.259,22.667,4.53,26.61-.675,3.65-20.133,23.215-20.133,23.215a8.5,8.5,0,0,1-2.7-3.1L301.2,172.838l-5.029-24.624Z",
    transform: "translate(-211.352 -109.188)",
    fill: "#a2d4ff"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M339.747,361.181l.014.088v0c.007.064.014.127.024.191s.018.129.031.2c.006.026.012.052.018.079,0,0,0,.005,0,.008.013.058.024.117.036.178a.073.073,0,0,0,0,.013l.015.08h0l13.378-.054s0-.023.007-.053a2.953,2.953,0,0,0,.013-.3,3.592,3.592,0,0,0-.036-.377l0-.014v0a.589.589,0,0,0-.019-.087,2.736,2.736,0,0,0-2.531-2.117,2.644,2.644,0,0,0-.282-.044h-.008c-.143-.02-.286-.033-.44-.046l-.151-.01q-.575-.043-1.084-.115-.262-.035-.508-.078-.294-.05-.563-.107t-.509-.119c-.149-.037-.292-.076-.428-.116-.183-.053-.352-.107-.511-.162-.2-.069-.383-.138-.547-.205-.188-.077-.353-.152-.493-.221a4.342,4.342,0,0,1-.646-.371l-.011,0a11.607,11.607,0,0,1-4.1.014,4.554,4.554,0,0,0-.314.7c-.01.026-.019.052-.028.079-.032.088-.063.183-.094.285s-.065.236-.1.366c-.008.024-.014.05-.021.08-.013.051-.024.109-.034.168a.374.374,0,0,0-.008.053c0,.013-.008.019-.008.029a6.551,6.551,0,0,0-.106.905,6.977,6.977,0,0,0,.034,1.084",
    transform: "translate(-250.746 -263.818)",
    fill: "#3a57b0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M360.1,357.615a.241.241,0,0,0-.169-.069.277.277,0,0,0-.169.071l-.111.087q-.264.205-.537.4a.257.257,0,0,0-.109.144.239.239,0,0,0,.352.269q.381-.269.744-.561a.24.24,0,0,0,.069-.169.244.244,0,0,0-.071-.169",
    transform: "translate(-264.988 -263.913)",
    fill: "#fff"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M363.63,359.231a.243.243,0,0,0-.338,0,4.048,4.048,0,0,1-.58.556l-.1.076a.257.257,0,0,0-.109.144.239.239,0,0,0,.352.269,4.306,4.306,0,0,0,.779-.708.254.254,0,0,0,.069-.169.243.243,0,0,0-.07-.169",
    transform: "translate(-267.564 -265.107)",
    fill: "#fff"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M367.5,360.394a.241.241,0,0,0-.169-.069.23.23,0,0,0-.169.071l-.539.7a.261.261,0,0,0-.069.169.239.239,0,0,0,.24.238.23.23,0,0,0,.169-.071l.54-.7a.261.261,0,0,0,.069-.169.243.243,0,0,0-.071-.169",
    transform: "translate(-270.559 -265.964)",
    fill: "#fff"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M371.834,361.352a.243.243,0,0,0-.328.089l-.351.608a.239.239,0,1,0,.407.25l.352-.608a.242.242,0,0,0-.08-.339",
    transform: "translate(-273.93 -266.701)",
    fill: "#fff"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M339.909,371.979c.016.126.032.255.058.386.024.116.044.237.073.36l13.378-.054a2.357,2.357,0,0,0,.022-.355,3,3,0,0,0-.04-.392Z",
    transform: "translate(-250.895 -274.526)",
    fill: "#7187ff"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M272.3,328.3l-.057.068h0c-.045.047-.087.094-.129.143s-.085.1-.129.152l-.048.065,0,.006c-.035.047-.073.1-.111.144a.063.063,0,0,0-.008.01l-.051.064,0,0,8.794,10.082.044-.03a2.912,2.912,0,0,0,.238-.187,3.608,3.608,0,0,0,.261-.274l.009-.011h0a.576.576,0,0,0,.053-.072,3.448,3.448,0,0,0-.205-3.541l-.005-.006c-.079-.121-.162-.239-.253-.363-.031-.04-.06-.081-.091-.12q-.344-.463-.622-.895-.145-.222-.273-.435-.154-.255-.287-.5t-.243-.463c-.07-.137-.134-.271-.192-.4-.08-.173-.15-.337-.212-.492-.08-.2-.147-.38-.2-.548-.065-.193-.116-.367-.156-.518a4.322,4.322,0,0,1-.142-.731l-.009-.007a11.593,11.593,0,0,1-2.693-3.091,4.554,4.554,0,0,0-.734.22l-.078.03c-.087.033-.18.072-.277.116s-.221.105-.34.167c-.024.01-.047.023-.074.036-.047.023-.1.054-.149.084a.364.364,0,0,0-.045.029c-.01.009-.02.007-.027.013a6.553,6.553,0,0,0-.754.512,6.95,6.95,0,0,0-.8.735",
    transform: "translate(-200.597 -240.893)",
    fill: "#3a57b0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M295.939,341.05a.24.24,0,0,0-.058-.173.276.276,0,0,0-.164-.081l-.138-.026q-.328-.066-.652-.146a.257.257,0,0,0-.18.011.239.239,0,0,0,.027.442c.3.075.605.139.911.2a.24.24,0,0,0,.173-.058.243.243,0,0,0,.081-.164",
    transform: "translate(-217.462 -251.414)",
    fill: "#fff"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M296.712,345.042a.242.242,0,0,0-.222-.255,4.082,4.082,0,0,1-.8-.075l-.124-.028a.257.257,0,0,0-.18.011.239.239,0,0,0,.027.442,4.285,4.285,0,0,0,1.045.126.255.255,0,0,0,.174-.058.243.243,0,0,0,.081-.164",
    transform: "translate(-217.933 -254.412)",
    fill: "#fff"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M298.29,348.642a.24.24,0,0,0-.058-.173.23.23,0,0,0-.164-.082l-.882.05a.261.261,0,0,0-.173.058.243.243,0,0,0-.081.164.24.24,0,0,0,.058.173.229.229,0,0,0,.164.081l.882-.049a.262.262,0,0,0,.174-.058.243.243,0,0,0,.081-.164",
    transform: "translate(-219.172 -257.152)",
    fill: "#fff"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M300.569,352.159a.243.243,0,0,0-.281-.19l-.69.132a.239.239,0,1,0,.077.472l.69-.132a.242.242,0,0,0,.2-.282",
    transform: "translate(-220.985 -259.794)",
    fill: "#fff"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M272.249,334.031c-.085.095-.172.191-.254.3s-.15.189-.224.291l8.794,10.082a2.33,2.33,0,0,0,.283-.216,2.977,2.977,0,0,0,.269-.286Z",
    transform: "translate(-200.601 -246.557)",
    fill: "#7187ff"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M302.925,150.168l9.13-.268c2.59,13.357,5.225,54.346,5.225,54.346s-1.117.74-4.1.014c-2.721-20.93-11.533-43.462-10.255-54.092",
    transform: "translate(-223.503 -110.645)",
    fill: "#b3dcff"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M295.251,189.832s3.792,4.419,5.533,5.512l.729-1.2.037-.06L304.627,189l.49,7.089,0,.07.067.962a24.331,24.331,0,0,0,7.343-.707l-.121-1.074-.008-.07-1.449-12.835s4.949-5.819,5.657-8.321-3.1-19.852-5.389-26.188l-13.868.786c-1.727,10.439,5.279,31.005,5.279,31.005l-6.5,8.913-.043.059Z",
    transform: "translate(-217.932 -109.187)",
    fill: "#4275e2"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M344.264,185.582q-.727-6.018-1.456-12.037-.724-5.988-1.448-11.976-.41-3.391-.82-6.782c-.006-.045.065-.045.07,0q.728,6.019,1.455,12.037.724,5.988,1.448,11.976.41,3.391.82,6.782c.005.045-.065.045-.071,0",
    transform: "translate(-251.362 -114.228)",
    fill: "#114bbc"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M343.532,154.031q.185,1.238.3,2.485.059.63.1,1.261.02.311.036.622a4.548,4.548,0,0,1,.01.6.981.981,0,0,1-.183.531.6.6,0,0,1-.423.244c-.045,0-.045-.067,0-.07a.533.533,0,0,0,.377-.229.925.925,0,0,0,.16-.484,4.587,4.587,0,0,0-.01-.572q-.015-.3-.035-.6-.077-1.205-.218-2.405-.081-.68-.181-1.357c-.007-.045.061-.064.068-.019",
    transform: "translate(-253.426 -113.675)",
    fill: "#114bbc"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M324.168,270.471q.5,1.619.879,3.271t.639,3.326q.145.935.252,1.874c.005.045-.065.045-.07,0q-.191-1.678-.5-3.339t-.742-3.287q-.242-.918-.522-1.826c-.013-.043.054-.062.068-.019",
    transform: "translate(-239.225 -199.623)",
    fill: "#114bbc"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M298.437,303.416q.342.461.7.906.624.769,1.3,1.49t1.4,1.384q.731.669,1.508,1.282.252.2.508.391l.037-.06q-.356-.266-.7-.546-.765-.616-1.484-1.287t-1.38-1.386q-.668-.72-1.281-1.488-.293-.368-.573-.744Z",
    transform: "translate(-220.284 -223.915)",
    fill: "#114bbc"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M332.928,329.532l0,.07q.632-.026,1.263-.068.868-.057,1.733-.144t1.737-.2q.858-.114,1.712-.256.422-.07.843-.148l-.008-.07q-.528.1-1.059.184-1.713.278-3.441.443-1.39.132-2.786.191",
    transform: "translate(-245.742 -242.632)",
    fill: "#114bbc"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M303.842,14.43a5.555,5.555,0,0,1,3.736,4.509,6.865,6.865,0,0,0,.479,2.741,5.416,5.416,0,0,0,1.893,1.545,2.565,2.565,0,0,1,1.387,1.918c.019,1.5-2.157,2.379-2.03,3.873.112,1.314,1.915,1.878,2.248,3.155a2.065,2.065,0,0,1-.52,1.819,4.837,4.837,0,0,1-1.609,1.109,15.757,15.757,0,0,1-14.088-.366,5.236,5.236,0,0,1-1.7-1.314,2.283,2.283,0,0,1-.46-2.027,4.323,4.323,0,0,1,1.286-1.626,2.285,2.285,0,0,0,.873-1.819c-.163-1.148-1.749-1.66-1.937-2.8-.166-1.011.828-1.788,1.314-2.69a3.122,3.122,0,0,0,.191-.43,4.865,4.865,0,0,0,.247-1.286c.016-.221.024-.443.027-.665,0-.186.042-.363.039-.547a3.613,3.613,0,0,1,.741-2.339,2.857,2.857,0,0,1,2.383-1.086,4.675,4.675,0,0,1,3.435-1.893,5.31,5.31,0,0,1,2.062.223",
    transform: "translate(-216.345 -10.472)",
    fill: "#241f5d"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M339.411,76.57c2.124.33,4.022,9.206,4.022,9.206l1.558-8.1,2.369.262s-.632,5.69-.85,8.472c-.339,4.324-4.841,5.683-6.247.807-1.159-4.022-.852-10.644-.852-10.644",
    transform: "translate(-250.501 -56.518)",
    fill: "#a2d4ff"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M339.515,76.57c2.39.493,4.166,6.919,4.166,6.919-.961,1.007-3.934,1.587-3.934,1.587Z",
    transform: "translate(-250.604 -56.518)",
    fill: "#7187ff"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M303.279,94.151c11.735,1.024,13.868-.785,13.868-.785-.1-.553-2.324-7.836-2.324-7.836,1.868-.849,2.228-5.245-.966-6.958l-1.089-3.893-2.684-.671-3.4.312-2.772,1.207,1.147,14.251a13.575,13.575,0,0,0-1.781,4.373",
    transform: "translate(-223.858 -54.628)",
    fill: "#7187ff"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M343.589,97.621a2.389,2.389,0,0,0,1.054-1.132,3.83,3.83,0,0,0,.321-1.514,4.975,4.975,0,0,0-.168-1.416,4.24,4.24,0,0,0-.258-.684,5.77,5.77,0,0,0-.516-.889,4.606,4.606,0,0,0-1.5-1.376c-.074-.041-.149-.079-.225-.116-.041-.019-.006-.08.035-.061a4.52,4.52,0,0,1,1.6,1.312,5.648,5.648,0,0,1,.559.872,4.488,4.488,0,0,1,.546,2.183,4.116,4.116,0,0,1-.261,1.559,2.523,2.523,0,0,1-.967,1.216c-.059.038-.12.073-.182.105-.04.021-.076-.04-.035-.061",
    transform: "translate(-252.642 -66.749)",
    fill: "#3e61d6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M339.839,77.579l.777,2.779.216.77a.035.035,0,0,1-.068.019l-.777-2.779-.215-.77a.035.035,0,0,1,.068-.019",
    transform: "translate(-250.792 -57.245)",
    fill: "#3e61d6"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M319.816,30.073c0,.024-.006.047-.007.071s-.005.052-.009.079A4.232,4.232,0,0,1,318.462,33a11.166,11.166,0,0,1-1,.794c-.1.07-.184.136-.271.2-.068.051-.131.1-.2.158-.661.542-1.039,1.142-.978,2.882a1.949,1.949,0,0,1-3.59.129,17.334,17.334,0,0,0-.908-5.07c-.1-.3-.2-.56-.28-.767-.157-.4-.268-.613-.268-.613s-.066-4.633.557-5.886c1.518-3.023,7.249-2.212,7.776.135a16.186,16.186,0,0,1,.508,5.105",
    transform: "translate(-229.537 -16.882)",
    fill: "#b3dcff"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M318.2,25.784a3.621,3.621,0,0,1-3.182-2.028,3.385,3.385,0,0,1-3.077,2.041,3.174,3.174,0,0,1-3.081,2.925,13.564,13.564,0,0,1-.239-3.032,4.8,4.8,0,0,1,1.093-2.8,4.465,4.465,0,0,1,2.493-1.334,8.326,8.326,0,0,1,2.863.02,3.918,3.918,0,0,1,2,.767,3.008,3.008,0,0,1,.891,1.584,9.193,9.193,0,0,1,.234,1.853",
    transform: "translate(-227.785 -15.829)",
    fill: "#241f5d"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M334.628,48.605a.659.659,0,0,1,.263-.068.373.373,0,0,1,.24.06.3.3,0,0,1,.113.226.55.55,0,0,1-.057.245.089.089,0,0,1-.106.059.087.087,0,0,1-.059-.106.475.475,0,0,0,.051-.179.154.154,0,0,0-.026-.09l0,0a.115.115,0,0,0-.08-.044h-.008l-.019,0h-.052l-.026,0h-.012a.912.912,0,0,0-.151.047.086.086,0,0,1-.1-.037.087.087,0,0,1,.032-.118",
    transform: "translate(-246.966 -35.826)",
    fill: "#6a7ae6"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M337.648,40.14a1.563,1.563,0,0,0-1.44-.244.246.246,0,0,0-.158.3.259.259,0,0,0,.353.143,1.08,1.08,0,0,1,.885.133l.031.02a.248.248,0,0,0,.341-.013.246.246,0,0,0-.012-.343",
    transform: "translate(-248.037 -29.389)",
    fill: "#241f5d"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M326.561,40.1a1.563,1.563,0,0,0-1.438.255.243.243,0,0,0,.294.387,1.172,1.172,0,0,1,.408-.207l-.019.008a1.165,1.165,0,0,1,.555,0c.126.028.274.015.327-.125a.246.246,0,0,0-.127-.319",
    transform: "translate(-239.91 -29.548)",
    fill: "#241f5d"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M327.235,45.73a.393.393,0,1,0,.413-.372.393.393,0,0,0-.413.372",
    transform: "translate(-241.54 -33.479)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M328.848,46.076a.114.114,0,1,0,.12-.108.114.114,0,0,0-.12.108",
    transform: "translate(-242.73 -33.93)",
    fill: "#fff"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M338.185,45.627a.393.393,0,1,0,.413-.372.393.393,0,0,0-.413.372",
    transform: "translate(-249.622 -33.403)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M339.8,45.973a.114.114,0,1,0,.12-.108.114.114,0,0,0-.12.108",
    transform: "translate(-250.812 -33.854)",
    fill: "#fff"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M331.067,52.734c.117-.146.367.045.681.1s.616-.033.674.145c.073.224-.291.683-.807.589s-.7-.651-.548-.835",
    transform: "translate(-244.332 -38.884)",
    fill: "#394bc0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M331.141,54.206a2.466,2.466,0,0,1,.319.037,1.575,1.575,0,0,1,.794.334.733.733,0,0,1-1.113-.371",
    transform: "translate(-244.423 -40.011)",
    fill: "#6a7ae6"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M332.087,53.014c-.281-.051-.508-.162-.568-.329.134-.027.345.106.6.152s.5,0,.615.069a.7.7,0,0,1-.647.108",
    transform: "translate(-244.702 -38.885)",
    fill: "#97fcff"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M305.061,47.8a1.122,1.122,0,1,0-.109-1.755,1.261,1.261,0,0,0,.109,1.755",
    transform: "translate(-224.866 -33.816)",
    fill: "#b3dcff"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M306.246,47.5a.843.843,0,0,1,.741-.012.688.688,0,0,1,.291.21.42.42,0,0,1,.074.384.594.594,0,0,1-.195.247.572.572,0,0,0-.132.142.215.215,0,0,0,.286.293.1.1,0,1,1,.086.17.4.4,0,0,1-.165.042.4.4,0,0,1-.376-.6.723.723,0,0,1,.174-.2.443.443,0,0,0,.14-.166.231.231,0,0,0-.045-.206.192.192,0,0,0-.345.033.342.342,0,0,0-.073.283.1.1,0,0,1-.075.112l-.016,0a.1.1,0,0,1-.1-.076.528.528,0,0,1,.115-.444.435.435,0,0,1,.139-.1.6.6,0,0,0-.433.045.369.369,0,0,0-.169.455.1.1,0,1,1-.17.086.559.559,0,0,1,.245-.707",
    transform: "translate(-225.832 -34.992)",
    fill: "#6a7ae6"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M355.437,73.285a1.534,1.534,0,0,0,1.675,1.3,2.223,2.223,0,0,0,4.178-1.057v-1.8h-4.446v.348c-.764-.1-1.527.323-1.408,1.206m1.375-.6.033.005v.837a2.232,2.232,0,0,0,.046.454.906.906,0,0,1-.78-.519c-.261-.562.162-.891.7-.777",
    transform: "translate(-262.348 -52.946)",
    fill: "#3a57b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(93.077 6.708)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M355.805,32.381a2.611,2.611,0,0,0,1.167.567,2.766,2.766,0,0,1,1.176.551.93.93,0,0,1,.2,1.182c-.215.283-.62.359-.853.628a1.011,1.011,0,0,0,.2,1.341,2.616,2.616,0,0,0,1.366.587,3.2,3.2,0,0,0,.788.021,1.612,1.612,0,0,0,.829-.3,1.229,1.229,0,0,0,.46-.915c.014-.378-.27-.672-.462-.974a1.282,1.282,0,0,1-.246-1.057,1.051,1.051,0,0,1,.925-.626,4.525,4.525,0,0,1,1.171.13,6.479,6.479,0,0,0,2.67-.11,3.2,3.2,0,0,0,1.134-.5,1.6,1.6,0,0,0,.654-1.022,1.707,1.707,0,0,0-.838-1.584,4.637,4.637,0,0,0-1.787-.578,6.037,6.037,0,0,1-1.818-.493,1.859,1.859,0,0,1-1.065-1.461,5.536,5.536,0,0,1,.111-.914,1.082,1.082,0,0,0-.2-.87,1.234,1.234,0,0,0-.732-.307,2.843,2.843,0,0,0-1.56.1A1.311,1.311,0,0,0,358.248,27a2.347,2.347,0,0,0,.7,1.222,1.453,1.453,0,0,1,.442,1.3c-.178.545-.865.725-1.437.692a3.992,3.992,0,0,0-1.7.023,1.314,1.314,0,0,0-.449,2.149m7.721-.9a.617.617,0,0,0,.314-.435,2.152,2.152,0,0,1,.072-.449c.138-.3.539-.26.811-.206a1.438,1.438,0,0,1,.789.412,1.066,1.066,0,0,1,.235.935,1.236,1.236,0,0,1-1.57.881,1.271,1.271,0,0,1-.8-.432.5.5,0,0,1,.153-.707",
    transform: "translate(-355.424 -25.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M383,29.833a.894.894,0,0,1-.663.172,1.3,1.3,0,0,1-.994-.67,1.554,1.554,0,0,1,.066-1.467c.236-.349.928-.885,1.231-.279.156.312-.087.711.054,1.03.1.232.381.35.483.583a.561.561,0,0,1-.178.631",
    transform: "translate(-374.445 -26.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M362.391,35.153a.529.529,0,0,1-.512.252,1.224,1.224,0,0,1-.842-.359c-.343-.348-.325-1.215.335-1.1.4.067,1.216.758,1.018,1.211",
    transform: "translate(-359.405 -31.754)",
    fill: "#fff"
  }))))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M304.968,79.808c-1.446.521,3.582,9.747,4.477,11.464s3.819,2.441,5.632-.363a61.683,61.683,0,0,0,4.038-8.712l-2.074-1.422-4.516,7.286-3.539-6.62Z",
    transform: "translate(-224.913 -58.908)",
    fill: "#b3dcff"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M351.8,74.617c.3-.352.185-1.658.608-2.29a1.764,1.764,0,0,1,1.537-.845c.365.092.618.426.5.671.523.157.525.635.352.811a.49.49,0,0,1,.086.869c.41.184.272.817,0,.946-.355.151-.647,1.04-1,1.261Z",
    transform: "translate(-259.672 -52.751)",
    fill: "#b3dcff"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M303.556,79.808c-2.678,1.077,2.579,9.072,2.579,9.072a8.745,8.745,0,0,0,4.714-3l-3.082-4.722Z",
    transform: "translate(-223.501 -58.908)",
    fill: "#7187ff"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M325.32,90.836q-.483-.867-1.028-1.7t-1.144-1.611q-.343-.447-.7-.879c-.029-.035.021-.085.05-.05q.636.762,1.216,1.569t1.1,1.659q.294.48.569.973c.022.04-.039.075-.061.036",
    transform: "translate(-237.998 -63.913)",
    fill: "#3e61d6"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M307.245,100.249l1.627,2.95.454.823c.022.04-.039.075-.061.036l-1.628-2.95-.454-.823c-.022-.04.039-.075.061-.036",
    transform: "translate(-226.737 -73.983)",
    fill: "#3e61d6"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M397.358,120.493h-6.221l.573-8.24h5.075Z",
    transform: "translate(-288.708 -82.857)",
    fill: "#4971e7"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M380.462,107.472a1.567,1.567,0,0,1,1.341.686c.325.412.534.9.839,1.333a1.727,1.727,0,0,0,1.279.82c-.08.758-.162,1.5-.242,2.26a2.66,2.66,0,0,1-1.411-1.288c-.334-.552-.55-1.166-.837-1.744a3.316,3.316,0,0,0-1.229-1.458.791.791,0,0,1,.26-.608",
    transform: "translate(-280.634 -79.322)",
    fill: "#4971e7"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M397.188,107.855h-6.409l.162-.369a2,2,0,0,1,1.826-1.192H395.2a2,2,0,0,1,1.827,1.192Z",
    transform: "translate(-288.444 -78.458)",
    fill: "#3a57b0"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 0.681,
    height: 0.681,
    transform: "translate(105.199 27.418)",
    fill: "#3a57b0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M400.692,101.524c0,.372-.572.674-1.278.674s-1.278-.3-1.278-.674.572-.674,1.278-.674,1.278.3,1.278.674",
    transform: "translate(-293.874 -74.44)",
    fill: "#3a57b0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.b5578bbb221f411c3d22c7234b97985f.svg";
export { ForwardRef as ReactComponent };